module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("Feedback")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.hasProvidedFeedback) ? _c('dismissable-alert', {
    attrs: {
      "title": _vm.previousFeedbackMessage,
      "closeAction": _vm.hidePreviousFeedbackMessage,
      "isShowing": _vm.showPreviousFeedbackMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('dismissable-alert', {
    attrs: {
      "title": "Thank you! Your feedback has been submitted.",
      "closeAction": _vm.hideSubmittedAlert,
      "isShowing": _vm.feedbackWasSubmitted
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "feedback-survey"
  }, [_c('h3', {
    staticClass: "survey-title"
  }, [_vm._v("\n          Thank you for taking a moment to provide feedback\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "survey-question"
  }, [_c('p', {
    staticClass: "question-text"
  }, [_vm._v("\n            How satisfied are you with your investment in the Community\n            Investment Note?\n          ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-scale",
    attrs: {
      "role": "radiogroup",
      "aria-label": "Satisfaction score from 0 to 10"
    }
  }, _vm._l((_vm.scoreOptions), function(value) {
    return _c('button', {
      key: ("score-" + value),
      staticClass: "score-option",
      class: {
        'score-option-selected': _vm.score === value
      },
      attrs: {
        "type": "button",
        "role": "radio",
        "aria-checked": _vm.score === value ? 'true' : 'false',
        "aria-label": ("Score " + value)
      },
      on: {
        "click": function($event) {
          _vm.selectScore(value)
        }
      }
    }, [_c('span', {
      staticClass: "score-label"
    }, [_vm._v(_vm._s(value))]), _vm._v(" "), _c('span', {
      staticClass: "score-circle"
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "survey-question"
  }, [_c('p', {
    staticClass: "question-text"
  }, [_vm._v("\n            What is the primary reason for your score? How could we improve\n            your experience?\n          ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control reason-input",
    attrs: {
      "rows": "4",
      "maxlength": "2000",
      "placeholder": "Enter text"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n        Submit feedback\n      ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scale-legend"
  }, [_c('span', [_vm._v("0 = Not at all")]), _vm._v(" "), _c('span', [_vm._v("10 = Very satisfied")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65c9b9be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedbackSurvey.vue
// module id = 2163
// module chunks = 1